module.exports = __webpack_public_path__ + "static/img/11@2x.d264b5ab.png";